(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    // Zamykanie listy języków: klik poza nią i Escape (fokus wraca na przycisk).
  (function () {
    if (window.__languageSwitcherBound) return;
    window.__languageSwitcherBound = true;

    document.addEventListener('click', function (event) {
      document.querySelectorAll('[data-language-switcher][open]').forEach(function (details) {
        if (!details.contains(event.target)) details.open = false;
      });
    });

    // Faza capture: Escape zamyka najpierw listę, a nie całe menu mobilne.
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
        var details = event.target.closest('[data-language-switcher][open]');
        if (!details) return;
        event.stopPropagation();
        details.open = false;
        var summary = details.querySelector('summary');
        if (summary) summary.focus();
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
